<template>
  <tr
    :class="{ 'is-selected has-background-info': estaSeleccionado }"
    @click="seleccionarItem"
  >
    <td>{{ item.id }}</td>
    <td>{{ item.nombre }}</td>
    <td class="has-text-centered">
      <div class="field">
        <b-icon
          size="is-medium"
          :icon="definirIcono(item.estaDisponible)"
          :type="definirColor(item.estaDisponible)"
        />
      </div>
    </td>
  </tr>
</template>

<script>
import disponibilidadMixin from '@/mixins/disponibilidad.js'

export default {
  name: 'GrillaItem',
  mixins: [disponibilidadMixin],
  props: {
    item: {
      type: Object,
      required: true
    },
    seleccionado: {
      type: String,
      required: false,
      default: null
    }
  },
  computed: {
    estaSeleccionado() {
      return this.seleccionado === this.item.id
    }
  },
  methods: {
    seleccionarItem() {
      this.$emit('seleccionar', this.item)
    }
  }
}
</script>
